import * as React from 'react'
import * as ReactStrap from 'reactstrap'
import { getConfiguration } from '../../utils'
import { UnsubscribeLayoutAttributes } from '../constants'

export const HeaderComponent = ({data}) =>
  <ReactStrap.Navbar className="rasa-public-header">
    <ReactStrap.Nav className="center">
      <ReactStrap.NavItem className="center">
        {getConfiguration(data, UnsubscribeLayoutAttributes.ShowHeader) ?
          getConfiguration(data, UnsubscribeLayoutAttributes.HeaderImageUrl) ?
          <img className="brand-header" src={
            getConfiguration(data, UnsubscribeLayoutAttributes.HeaderImageUrl)}/> :
            getConfiguration(data, UnsubscribeLayoutAttributes.BrandHeaderImageUrl) ?
          <img className="brand-header" src={
            getConfiguration(data, UnsubscribeLayoutAttributes.BrandHeaderImageUrl)}/> : null : null}

      </ReactStrap.NavItem>
    </ReactStrap.Nav>
  </ReactStrap.Navbar>
